<template>
  <div class="simple-layout">
    <router-view />
  </div>
</template>

<script setup lang="ts" name="SimpleLayout">
// 简单布局，用于登录页等不需要侧边栏的页面
</script>

<style lang="scss" scoped>
.simple-layout {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
</style>
